module.exports = __webpack_public_path__ + "img/dream-sm.58a7b71f.svg";